const createAlert = (type, text, persistent=false) => {
  const template = `<div class="alert alert-${type} alert-dismissible fade show ${persistent ? 'persistent' : ''}" role="alert">
    ${text}
  </div>`;

  $('body').append(template);

  $('.alert').not('.persistent').not('.alert-danger').delay(3000).fadeOut(3000);
}

const clearAlerts = () => {
  $('.alert').remove();
}

module.exports = { createAlert, clearAlerts };